import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { createDivAtom } from 'shared/atoms/factory'

import styles from './ExportStatusLabel.module.scss'

const Wrapper = createDivAtom()

const STATUSES = {
  pending: 'pending',
  inProgress: 'in-progress',
  completed: 'completed',
  failure: 'failure'
}

const getTitle = status => {
  switch(status) {
    case STATUSES.pending: {
      return 'pending'
    }

    case STATUSES.inProgress: {
      return 'in progress'
    }

    case STATUSES.completed: {
      return 'completed'
    }

    case STATUSES.failure: {
      return 'failure'
    }
  }
}

const getClassName = status => {
  switch(status) {
    case STATUSES.pending: {
      return styles.pending
    }

    case STATUSES.inProgress: {
      return styles.inProgress
    }

    case STATUSES.completed: {
      return styles.completed
    }

    case STATUSES.failure: {
      return styles.failure
    }
  }
}

const ExportStatusLabel = props => {
  const {
    status
  } = props

  const title = getTitle(status)
  const className = getClassName(status)

  return (
    <Wrapper className={classNames(className, styles.label)} >
      {title}
    </Wrapper>
  )
}

ExportStatusLabel.propTypes = {
  status: PropTypes.string
}

export default ExportStatusLabel
